import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import LoggerService from './service/LoggerService';
import LoggingLevel from './constants/LoggingLevel';
import LoggingConfig from './common/LoggingConfig';
import LoggingEventType from './constants/LoggingEventType';
import LoggingPayload from './common/LoggingPayload';
import LoggingUtil from './common/LoggingUtil';
import { LOGGER_FACTORY_URL } from './constants/loggingConstants';
var instance;
var debugEnabled = false;

var getLogger = function getLogger() {
  if (!instance) {
    throw new Error("LoggerFactory is not properly configured, please check documentation @ ".concat(LOGGER_FACTORY_URL, " for further details"));
  }

  return instance;
};

var initialize = function initialize(config) {
  var logConfig = LoggingConfig.initialize(config);
  instance = new Logger(logConfig);
};

var setDebugEnabled = function setDebugEnabled(enabled) {
  debugEnabled = enabled;
};

var getDebugEnabled = function getDebugEnabled() {
  return debugEnabled || false;
};

var _createLogPayload = function _createLogPayload(payload, level) {
  var logPayload = LoggingPayload.initialize(payload);
  return Object.assign({}, logPayload, {
    severity: level
  });
};

var Logger = /*#__PURE__*/function () {
  function Logger(config) {
    _classCallCheck(this, Logger);

    this.config = config;
  }

  _createClass(Logger, [{
    key: "trace",
    value: function trace(payload) {
      var logPayload = _createLogPayload(payload, LoggingLevel.TRACE);

      LoggerService.sendLogEvent(this.config, logPayload, getDebugEnabled());
    }
  }, {
    key: "debug",
    value: function debug(payload) {
      if (getDebugEnabled()) {
        // eslint-disable-next-line no-console
        console.debug(LoggingUtil.get(payload, 'description', ''), LoggingUtil.get(payload, 'details', ''));
      }

      var logPayload = _createLogPayload(payload, LoggingLevel.DEBUG);

      LoggerService.sendLogEvent(this.config, logPayload, getDebugEnabled());
    }
  }, {
    key: "error",
    value: function error(payload) {
      if (getDebugEnabled()) {
        // eslint-disable-next-line no-console
        console.error(LoggingUtil.get(payload, 'description', ''), LoggingUtil.get(payload, 'details', ''));
      }

      var logPayload = _createLogPayload(payload, LoggingLevel.ERROR);

      LoggerService.sendLogEvent(this.config, logPayload, getDebugEnabled());
    }
  }, {
    key: "info",
    value: function info(payload) {
      var logPayload = _createLogPayload(payload, LoggingLevel.INFO);

      LoggerService.sendLogEvent(this.config, logPayload, getDebugEnabled());
    }
  }, {
    key: "warn",
    value: function warn(payload) {
      var logPayload = _createLogPayload(payload, LoggingLevel.WARN);

      LoggerService.sendLogEvent(this.config, logPayload, getDebugEnabled());
    }
  }]);

  return Logger;
}(); // the following if condition is necessary because window is not known to Node.js


if (typeof window !== 'undefined') {
  window.onerror = function (message, url, lineno, colno, error) {
    try {
      var logger = getLogger();
      logger.error({
        description: message,
        eventType: LoggingEventType.APPLICATION,
        eventName: 'Uncaught Exception',
        object: 'Uncaught Exception',
        error: error
      });
    } catch (e) {
      if (getDebugEnabled()) {
        // eslint-disable-next-line no-console
        console.debug('LoggerFactory is not configured', e);
      }
    }
  };
}

export default {
  initialize: initialize,
  getLogger: getLogger,
  setDebugEnabled: setDebugEnabled,
  getDebugEnabled: getDebugEnabled
};